export default __webpack_public_path__ + "static/media/ic_task.7ccebc78.svg";